import Matter from 'matter-js';

import { Dim, Entity } from '../../models';
import { posOf, dimsOf, getNoteDims } from '../../helpers';
import Bridge from '../renderers/Bridge';

const bridge = (
  windowDims: Dim,
  h: number,
  h0: number,
  xOff: number,
  y: number,
  timing: number
): Entity => {
  const bridgeWidth = getNoteDims(windowDims).w * 0.3;
  const body = Matter.Bodies.rectangle(
    windowDims.w / 2 + xOff,
    y - h / 2,
    bridgeWidth,
    h,
    { type: 'bridge' }
  );

  Matter.Body.setCentre(body, { x: 0, y: h / 2 }, true);

  return {
    dims: dimsOf(body),
    getDims: () => dimsOf(body),
    getPos: () => posOf(body),
    body,
    h0,
    xOff,
    timing,
    active: false,
    renderer: Bridge,
  };
};

export default bridge;
